module.exports = __webpack_public_path__ + "static/media/appstore.9d013d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/appstore.png
// module id = 474
// module chunks = 0